import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";

import DashboardLayout from "cxfcomponents/LayoutContainers/DashboardLayout";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <DashboardLayout>
      <SoftBox sx={{ margin: "auto" }}>
        <SoftTypography variant="h2">Something went wrong:</SoftTypography>
        <SoftTypography color="secondary">
          We apologize for the inconvenience. Please try again later.
        </SoftTypography>
        <SoftTypography fontWeight="light" variant="caption" color="error">
          {error.message}
        </SoftTypography>
        <SoftButton
          sx={{ display: "block", ml: "auto", mt: 2 }}
          size="small"
          color="info"
          onClick={resetErrorBoundary}
        >
          Reload Page
        </SoftButton>
      </SoftBox>
    </DashboardLayout>
  );
};

export default ErrorFallback;
